/* eslint-disable @typescript-eslint/no-unused-vars */

import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { InlineResponse200 } from '../entities/restricted-assets';
import { axiosInstance } from "../axios-instance";

class RestrictedAssets {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getRestrictedStatusByAssetSerialNumber(
    assetSerialNumber: string,
  ): Promise<AxiosResponse<InlineResponse200>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<InlineResponse200>(
      `${this.baseUrl}/assets/search`,
      { assetSerialNumber },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
}

export default RestrictedAssets;
